export default {
  width: 23,
  height: 22,
  svg: `
    <path d="M5.75 21.5458v-1.9091h11.5v1.9091H5.75zM2 2.54492V15.5449h19V2.54492H2zM0 .544922h23V17.5449H0V.544922z"/>
    <path fill-rule="evenodd" d="M11.4999 10.5449c-1.4143 0-2.57143-1.19998-2.57143-2.66664v-.66667c0-1.46667 1.15713-2.66667 2.57143-2.66667s2.5714 1.2 2.5714 2.66667v.66667c0 1.46666-1.1571 2.66664-2.5714 2.66664zM12.7857 11.1074h-2.5714C8.41429 11.1074 7 12.1799 7 13.5449h9c0-1.365-1.4143-2.4375-3.2143-2.4375z" clip-rule="evenodd"/>
  `
}
